'use strict';

import template from './confirmPasswordForm.component.html';

export const ConfirmPasswordFromComponent = {
	controller: ConfirmPasswordFromComponentCtrl,
	controllerAs: 'vm',
	template: template,
};

ConfirmPasswordFromComponentCtrl.$inject = ['$q', 'mx.SolutionBuilderAgent.WizardService', 'mx.shell.UserProfileService', 'mx.shell.AuthService', 'mx.internationalization'];
export function ConfirmPasswordFromComponentCtrl($q, wizardService, userProfileService, authService, i18n) {
	const vm = this;
	vm.isPasswordInvalid = true;

	vm.view = wizardService.getWizardView({
		widgetId: '2515ee90-a40f-c8b1-ea47-08d9275d7d1e',
		wizardMode: mx.SolutionBuilderAgent.WizardMode.Default,
		displayName: i18n.get('resetPassword.title'),
		selectedObjects: [],
	});

	vm.view.finishDefer = $q.defer();

	vm.view.finishDefer.promise.then(() => {
		hideForm();
		authService.logout();
	});

	function hideForm() {
		const form = document.getElementById('confirm-password-form');
		form.style.display = 'none';
	}

	vm.confirmPasswordRequest = async function () {
		vm.view.locals.wizard.finishWizard();
	};

	vm.cancel = async function () {
		authService.logout();
	};
}
